export const translation = {
    editor: {
        submit: 'Preview',
        placeholder: 'Enter formula here…',
        empty: {
            noColumnSelected: '<0><0/><1>Select a column</1> to edit its formula.</0> <1>Or use the plus button in the table to <2/> <3>add a new column.</3></1>',
            allColumnsHidden: '<0>No data, no fun!</0> <1>Use the plus button in the table to <2/> <3>add a new column</3></1> <2>or <2/> <3>unhide</3> an existing one in the inspector.</2>'
        }
    },
    grid: {
        add: 'Add Column'
    },
    sidebar: {
        title: 'Formula Builder'
    },
    columns: {
        title: 'Columns',
        search: 'Find column…',
        help: 'Use the checkboxes to toggle column visibility',
        rename: 'Rename column',
        remove: 'Remove column',
        insert: 'Insert column name at cursor',
        editing: 'Editing',
        empty: 'Sorry, no matching columns found.',
        filter: {
            all: 'All columns',
            formula: 'Only formula columns',
            unsaved: 'Only unsaved columns'
        },
        syncColumnsButton: 'Sync to Input Columns',
        syncColumnsHint: 'The input dataset has changed, resulting in 1 or more unmatched columns being present in the formula builder.'
    },
    functions: {
        title: 'Functions',
        search: 'Find function…',
        categories: {
            ALL: 'All',
            AGGREGATION: 'Aggregation',
            BITWISE: 'Bitwise',
            CONDITIONAL: 'Conditional',
            CONTEXT: 'Context',
            CONVERSION: 'Conversion',
            DATE: 'Date & Time',
            NUMERIC: 'Numeric',
            STRING: 'String & Binary',
            STRUCTURED: 'Structured Data',
            WINDOWING: 'Windowing'
        },
        add: 'Insert Function',
        empty: 'Sorry, no functions match "{{- term}}".'
    },
    errors: {
        listOfErrors: 'One or more errors occurred when generating the preview:'
    }
};
